import React, { useEffect, useState } from "react";
import { TextField, CircularProgress } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import Select from "@mui/material/Select";
import makeStyles from "utils/makeStyles";

import MenuItem from "@mui/material/MenuItem";

import _ from "lodash";

const MSeriesModulesDropDown = ({
  options,
  value,
  onChange,
  label,
  disabled,
  required,
  defaultValue,
  isLoading,
  backgroundColor,
}) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      height: 40,
    },
    selectRoot: {
      //...other styles
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
  }));
  const classes = useStyles();
  return (
    <>
      <FormControl variant="outlined" className={classes.formControl}>
        <Select
          classes={{ root: classes.selectRoot }}
          style={{ height: 40, background: backgroundColor ?? "transparent" }}
          value={value}
          defaultValue={defaultValue.value}
          onChange={(e) =>
            onChange(options.filter((item) => item.value == e.target.value)[0])
          }
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left"
            },
                    }}
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default MSeriesModulesDropDown;
